import { render, staticRenderFns } from "./Email.vue?vue&type=template&id=184cc0ca&scoped=true&"
import script from "./Email.vue?vue&type=script&lang=js&"
export * from "./Email.vue?vue&type=script&lang=js&"
import style0 from "./Email.vue?vue&type=style&index=0&id=184cc0ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184cc0ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('184cc0ca')) {
      api.createRecord('184cc0ca', component.options)
    } else {
      api.reload('184cc0ca', component.options)
    }
    module.hot.accept("./Email.vue?vue&type=template&id=184cc0ca&scoped=true&", function () {
      api.rerender('184cc0ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/Invite/Email.vue"
export default component.exports